import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Loader from "components/Loader";
import { LOCALES } from "common/constants";
import { lazyWithRetry } from "common/lazyWithRetry";
import { useLocalizedRoutes } from "../v2/hooks/useLocalizedRoutes";
import  LandingPage  from "./../v2/pages/landing-page.page";
const FaqPage = lazyWithRetry(() =>
  import("../v2/pages/faq-page.page").then((m) => ({ default: m.FaqPage }))
);
const FreelanceLifePage = lazyWithRetry(() =>
  import("./../v2/pages/freelance-life.page").then((m) => ({ default: m.FreelanceLifePage }))
);
const SelfEmploymentPage = lazyWithRetry(() =>
  import("./../v2/pages/self-employment.page").then((m) => ({ default: m.SelfEmploymentPage }))
);
const WorkConditionPage = lazyWithRetry(() =>
  import("../v2/pages/work-condition.page.tsx").then((m) => ({ default: m.WorkConditionPage }))
);
const BusinessOrInvoicePage = lazyWithRetry(() =>
  import("./../v2/pages/business-or-invoice.page").then((m) => ({ default: m.BusinessOrInvoicePage }))
);
const NewsPage = lazyWithRetry(() => import("./../v2/pages/news-page.page"));
const NewsDetailPage = lazyWithRetry(() => import("../v2/pages/news-detail.page"));
const BookKeepingPage = lazyWithRetry(() => import("./../v2/pages/book-keeping-page.page"));
const FreelancingGuide = lazyWithRetry(() => import("./../v2/pages/freelancing-guide-page.page"));
const ContactUsPage = lazyWithRetry(() =>
  import("../v2/pages/contact-us.page").then((m) => ({ default: m.ContactUsPage }))
);
const Business = lazyWithRetry(() =>
  import("../v2/pages/landing-page-bussiness.page").then((m) => ({ default: m.Business }))
);
const AmbassadorPage = lazyWithRetry(() =>
  import("../v2/pages/ambassador-page.page").then((m) => ({ default: m.AmbassadorPage }))
);
const SelfEmployedInvoicingPage = lazyWithRetry(() => import("../v2/pages/self-employed-invoicing.page.tsx"));
const AboutUsPage = lazyWithRetry(() => import("../v2/pages/about-us.page"));
const HowItWorksPage = lazyWithRetry(() => import("../v2/pages/how-it-works.page"));
const FeaturesPage = lazyWithRetry(() => import("../v2/pages/features.page"));
const PrivateInsurancePageMain = lazyWithRetry(() => import("../v2/pages/private-insurance-page"));
const InsurancePageMain = lazyWithRetry(() => import("../v2/pages/insurance-page"));
const PensionPagePage = lazyWithRetry(() => import("../v2/pages/pension-page"));
const HealthInsurancePage = lazyWithRetry(() => import("../v2/pages/healthInsurance-page"));
const FreelanceIncomePotentialPage = lazyWithRetry(() => import("../v2/pages/freelance-income-potential.page"));
const PrivacyPolicyPage = lazyWithRetry(() => import("../v2/pages/privacy-policy.page"));
// import { LoyaltyProgramPage } from "../v2/pages/loyalty-program.page";
// import RegistrationFormPage from "../v2/pages/registration-form.page";
const Faq = lazyWithRetry(() => import("../views/dashboard/Faq"));
// const DashboardView = lazyWithRetry(() => import("../views/dashboard"));
// const HomePage = lazyWithRetry(() => import("../views/index"));
const AboutUs = lazyWithRetry(() => import("components/layout/AboutUs"));
const SidebarInsurances = lazyWithRetry(() => import("components/layout/outer-header/SidebarInsurances"));
const SidebarWorkingConditions = lazyWithRetry(() =>
  import("components/layout/outer-header/SidebarWorkingConditions").then((m) => ({ default: m.SidebarWorkingConditions }))
);
const BussinesInfo = lazyWithRetry(() => import("components/layout/outer-header/BussinesInfo"));
// const CompareDiffForms = lazyWithRetry(() => import("components/layout/outer-header/CompareDiffForms"));
const InvoiceWithoutCompany2025 = lazyWithRetry(() => import("components/layout/outer-header/InvoiceWithoutCompany2025"));
const CompanyReview = lazyWithRetry(() => import("views/dashboard/seo-files/company-review/CompanyReview"));
// const InvoicingSelfEmployed = lazyWithRetry(() =>
//   import("views/dashboard/seo-files/InvoicingSelfEmployed").then((m) => ({ default: m.InvoicingSelfEmployed }))
// );
// const FreelanceFreelancing = lazyWithRetry(() =>
//   import("views/dashboard/seo-files/FreelanceFreelancing").then((m) => ({ default: m.FreelanceFreelancing }))
// );
const ApprovalNotifyPage = lazyWithRetry(() => import("components/ApprovalNotifyPage"));
const Unsubscribed = lazyWithRetry(() => import("components/Unsubscribed"));
const AuthorizedForReminder = lazyWithRetry(() => import("components/AuthorizedForReminder"));
// const CookiesPage = lazyWithRetry(() => import("components/layout/outer-header/cookiesPage"));
// const Ambassador = lazyWithRetry(() => import("components/layout/Ambassador"));
// const SelfEmployment = lazyWithRetry(() => import("components/layout/outer-header/SelfEmployment"));
// const InfoInspiration = lazyWithRetry(() => import("components/layout/outer-header/InfoInspiration"));
const Negotiation = lazyWithRetry(() => import("components/layout/outer-header/Negotiation"));
const GiggerVsInvozio = lazyWithRetry(() => import("views/dashboard/seo-files/comparison/GiggerVsInvozio"));
const FrilansVsInvozio = lazyWithRetry(() => import("views/dashboard/seo-files/comparison/FrilansVsInvozio"));
const CoolCompanyVsInvozio = lazyWithRetry(() => import("views/dashboard/seo-files/comparison/CoolCompanyVsInvozio"));
const Error = lazyWithRetry(() => import("views/Error"));
const DashboardView = lazyWithRetry(() => import("views/dashboard"));
// const PensionInsurance = lazyWithRetry(() => import("components/layout/outer-header/PensionInsurance"));
// const ManinHealthInsurance = lazyWithRetry(() => import("components/layout/outer-header"));
// const HealthInsurance = lazyWithRetry(() => import("components/layout/outer-header/HealthInsurance"));
const InvoiceAsConsultant = lazyWithRetry(() =>
  import("components/layout/outer-header/InvoiceAsConsultant").then((m) => ({ default: m.InvoiceAsConsultant }))
);

export const Router = ({ mobileScreen, dashboardFooter, language }) => {
  const { routes } = useLocalizedRoutes();
  return (
    <Routes>
      {/* Mobile Screen Pages Start */}
      <Route
        exact
        path="/mobile_faq"
        element={
          <Suspense
            fallback={
              <div>
                <Loader />
              </div>
            }
          >
            <Faq mobileScreen={mobileScreen} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/mobile_about_us"
        element={
          <Suspense fallback={<Loader />}>
            <AboutUs mobileScreen={mobileScreen} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/mobile_Insurance_admin"
        element={
          <Suspense fallback={<Loader />}>
            <SidebarInsurances mobileScreen={mobileScreen} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/mobile_goodworking_conditions"
        element={
          <Suspense fallback={<Loader />}>
            <SidebarWorkingConditions mobileScreen={mobileScreen} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/mobile_business_solution"
        element={
          <Suspense fallback={<Loader />}>
            <Business dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      {/* Mobile Screen Pages End */}

      <Route
        exact
        path="/"
        element={<LandingPage />}
      />

      <Route
        exact
        path={routes.function}
        element={
          <Suspense fallback={<Loader />}>
            <FeaturesPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path="/faq"
        element={
          <Suspense
            fallback={
              <div>
                <Loader />
              </div>
            }
          >
            <FaqPage />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US ? "/how-works-invozio" : "/hur-fungerar-invozio"
        }
        element={
          <Suspense fallback={<Loader />}>
            <HowItWorksPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/about-invozio" : "/om-invozio"}
        element={
          <Suspense fallback={<Loader />}>
            <AboutUsPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/contact-us" : "/kontakta-oss"}
        element={
          <Suspense fallback={<Loader />}>
            <ContactUsPage />
          </Suspense>
        }
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/dashboard/*" : "/instrumentbrada/*"}
        element={
          <Suspense fallback={<Loader />}>
            <DashboardView dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path={
          language === LOCALES.EN_US ? "/health-insurance-main" : "/sjukforsakring-huvud"
        }
        element={
          <Suspense fallback={<Loader />}>
            <HealthInsurancePage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/health-insurance" : "/sjukforsakring"}
        element={
          <Suspense fallback={<Loader />}>
            <HealthInsurancePage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path={routes.privateCareInsurance}
        element={
          <Suspense fallback={<Loader />}>
            <PrivateInsurancePageMain />
          </Suspense>
        }
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/pension" : "/pension"}
        element={
          <Suspense fallback={<Loader />}>
            <PensionPagePage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        path="/external-help-with-payroll-management"
        element={
          <Suspense fallback={<Loader />}>
            <BussinesInfo dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/freelance-consultant-salary-invoice-without-a-company"
            : "/frilans-konsult-lon-fakturera-utan-foretag"
        }
        element={
          <Suspense fallback={<Loader />}>
            <BusinessOrInvoicePage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/invoicing-without-company-2025"
            : "/fakturering-utan-foretag-2025"
        }
        element={
          <Suspense fallback={<Loader />}>
            <InvoiceWithoutCompany2025 dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      {/* <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/working-as-a-freelancer-and-invoicing-without-tax-registration"
            : "/att-jobba-som-frilansare-och-fakturera-utan-fskatt"
        }
        element={<WorkingAsFreelancer dashboardFooter={dashboardFooter} />}
      /> */}
      <Route
        exact
        path={routes.workingFreelancer}
        element={
          <Suspense fallback={<Loader />}>
            <FreelanceLifePage />
          </Suspense>
        }
      />
      {/* <Route
        exact
        path="/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger"
        element={
          <Suspense fallback={<Loader />}>
            <CompanyReview />
          </Suspense>
        }
      /> */}
      <Route
        exact
        path="/gigger-vs-Invozio"
        element={
          <Suspense fallback={<Loader />}>
            <GiggerVsInvozio />
          </Suspense>
        }
      />
      <Route
        exact
        path="/frilans-finans-vs-Invozio"
        element={
          <Suspense fallback={<Loader />}>
            <FrilansVsInvozio />
          </Suspense>
        }
      />
      <Route
        exact
        path="/cool-company-vs-Invozio"
        element={
          <Suspense fallback={<Loader />}>
            <CoolCompanyVsInvozio />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/how-much-should-I-invoice-as-a-freelancer"
            : "/hur-mycket-ska-jag-fakturera-som-frilansare"
        }
        element={
          <Suspense fallback={<Loader />}>
            <FreelanceIncomePotentialPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/from-invoice-to-negotiation"
            : "/fran-faktura-till-forhandling"
        }
        element={
          <Suspense fallback={<Loader />}>
            <Negotiation dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/business" : "/foretag"}
        // element={<Business dashboardFooter={dashboardFooter} />}
        element={
          <Suspense fallback={<Loader />}>
            <Business />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.selfEmployment}
        element={
          <Suspense fallback={<Loader />}>
            <SelfEmploymentPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.startBusiness}
        element={
          <Suspense fallback={<Loader />}>
            <WorkConditionPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.invoiceWithoutCompany}
        element={
          <Suspense fallback={<Loader />}>
            <BusinessOrInvoicePage />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.ambassador}
        element={
          <Suspense fallback={<Loader />}>
            <AmbassadorPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/cookies"
        element={
          <Suspense fallback={<Loader />}>
            <PrivacyPolicyPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/error"
        element={
          <Suspense fallback={<Loader />}>
            <Error />
          </Suspense>
        }
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/unsubscribed" : "/avprenumererad"}
        element={
          <Suspense fallback={<Loader />}>
            <Unsubscribed />
          </Suspense>
        }
      />
      <Route
        exact
        path={language === "en" ? "/authorize-reminder" : "/auktorisera-påminnelse"}
        element={
          <Suspense fallback={<Loader />}>
            <AuthorizedForReminder />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US ? "/approval-notify" : "/godkannande-meddelande"
        }
        element={
          <Suspense fallback={<Loader />}>
            <ApprovalNotifyPage />
          </Suspense>
        }
      />
      {/* <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/freelance-freelancing"
            : "/frilans-frilansarbete"
        }
        element={<FreelanceFreelancing dashboardFooter={dashboardFooter} />}
      /> */}
      <Route
        exact
        path={routes.freelancingGuide}
        element={
          <Suspense fallback={<Loader />}>
            <FreelancingGuide />
          </Suspense>
        }
      />
      {/* <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/freelance-income-potential"
            : "/frilans-inkomstpotential"
        }
        element={<FreelanceIncomePotentialPage dashboardFooter={dashboardFooter} />}
      /> */}

      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/invoice-as-consultant-salary"
            : "/fakturera-som-konsult-lon"
        }
        element={
          <Suspense fallback={<Loader />}>
            <InvoiceAsConsultant dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.newsDetail}

        element={
          <Suspense fallback={<Loader />}>
            <NewsDetailPage />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.news}
        element={
          <Suspense fallback={<Loader />}>
            <NewsPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
      <Route
        exact
        path={routes.bookKeeping}
        element={
          <Suspense fallback={<Loader />}>
            <BookKeepingPage />
          </Suspense>
        }
      />
      {/* <Route
        exact
        path={routes.loyaltyProgram}
        element={<LoyaltyProgramPage />}
      /> */}
      <Route
        exact
        path={routes.invoicingIndividual}
        element={
          <Suspense fallback={<Loader />}>
            <SelfEmployedInvoicingPage dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />

      <Route
        exact
        // path={language === LOCALES.EN_US ? "/insurance" : "/forsakring"}
        path={routes.insurance}
        element={
          <Suspense fallback={<Loader />}>
            <InsurancePageMain dashboardFooter={dashboardFooter} />
          </Suspense>
        }
      />
    </Routes>
  );
};
